import axios from "axios";
import { API_URL, authHeader, getValidToken } from "../utils/helper";
import { config } from "../utils/config";

export const getAllVehicle = (onSuccess = () => {}) => {
  const apiUrl = config.URL.FETCH_ALL_VEHICLE;
  return async () => {
    const token = await getValidToken();
    axios
      .get(apiUrl, authHeader(token))
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((e) => {
        console.error("There is an error when fetching vehicles", e);
      });
  };
};

export const getAllVehicleByMenu = (menu, onSuccess = () => {}) => {
  const apiUrl = `${config.URL.FETCH_ALL_VEHICLE_BY_MENU}${menu}`;
  return async () => {
    const token = await getValidToken();
    axios
      .get(apiUrl, authHeader(token))
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((e) => {
        console.error("There is an error when fetching vehicles", e);
      });
  };
};
export const createVehicle = (vehicle, onSuccess = () => {}) => {
  const apiUrl = config.URL.CREATE_VEHICLE;
  return async () => {
    const token = await getValidToken();
    axios
      .post(apiUrl, vehicle, authHeader(token))
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((e) => {
        console.error("There is an error when creating new vehicle", e);
      });
  };
};
export const removeVehicle = (vehicleId, onSuccess = () => {}) => {
  const apiUrl = `${config.URL.REMOVE_VEHICLE}${vehicleId}`;
  return async () => {
    const token = await getValidToken();
    axios
      .patch(apiUrl, {}, authHeader(token))
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((e) => {
        console.error("There is an error when you remove vehicle", e);
      });
  };
};
export const deleteVehicle = (vehicleId, onSuccess = () => {}) => {
  const apiUrl = `${config.URL.DELETE_VEHICLE}${vehicleId}`;
  return async () => {
    const token = await getValidToken();
    axios
      .delete(apiUrl, authHeader(token))
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((e) => {
        console.error("There is an error when you remove vehicle", e);
      });
  };
};

export const updateVehicle = (vehicle, onSuccess = () => {}) => {
  const apiUrl = config.URL.UPDATE_VEHICLE;
  return async () => {
    const token = await getValidToken();
    axios
      .put(apiUrl, vehicle, authHeader(token))
      .then((res) => {
        onSuccess(res.data);
      })
      .catch((e) => {
        console.error("There is an error when you updating vehicle info", e);
      });
  };
};
